import { useSelector } from "react-redux";
import HorizontalScrollList from "../../HorizontalScrollList";
import CategoryLinksList from "./CategoryLinksList";
import styles from "./CategoryHeaderLinks";
import { getCategoryHeaderLinks } from "../../../state/modules/category/selectors/composeCategoryHeaderLinks";

const CategoryHeaderLinks = () => {
  const links = useSelector(getCategoryHeaderLinks) || [];

  if (!Array.isArray(links) || links.length === 0) return null;

  return (
    <HorizontalScrollList
      scrollSnapping={false}
      className={styles.categoryHeaderLinks}
    >
      <CategoryLinksList links={links} />
    </HorizontalScrollList>
  );
};

export default CategoryHeaderLinks;
